<!-- 支付渠道管理 -->
<template>
  <div class="index">
    <div class="title">
      <span>{{ $route.name }}</span>
    </div>
    <div class="query" v-if="show">
      <div class="card" v-for="item in cardList" :key="item.type">
        <div class="tip" :style="{ background: item.style }">
          {{ item.status | applymentStateFilter }}
        </div>
        <div class="card_top" :style="{ background: item.background }">
          <div class="pay_content">
            <img :src="item.src" alt="" /><span>{{ item.name }}</span>
          </div>
        </div>
        <div class="card_bottom">
          <el-button
            :disabled="item.disabled"
            :loading="btnLoading"
            v-if="item.status == 'FINISH'"
            type="text"
            @click="see(item)"
            >  {{btnLoading?"":"查看"}} </el-button
          >
          <!-- placement="top-start" -->
          <el-popover
            title=""
            width="200"
            trigger="hover"
            content=""
          >
            <div style="margin:5px 5px;color:red">
              <i class="el-icon-warning"></i> <span>失败原因</span>
            </div>
            <p v-for="(it, index) in item.auditDetailList" :key="index">
              {{ it.rejectReason }}
            </p>
            <el-button
              slot="reference"
              :disabled="item.disabled"
              :loading="btnLoading"
              v-if="item.status == 'REJECTED' || item.status == 'FROZEN'"
              type="text"
              @click="uplate(item)"
              > {{btnLoading?"":"修改"}} </el-button
            >
          </el-popover>
          <el-button
            :disabled="item.disabled"
            :loading="btnLoading"
            v-if="item.status == 'NEED_SIGN' ||item.status == 'REJECTED'||item.status == 'CANCELED' "
            type="text"
            @click="open(item)"
            >{{btnLoading?"":"立即开通"}}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryWechatMer,
  queryPayChannelStatus,
} from "@/api/mechanismApi/curriculum.js";
import { handleGetPersonStatus } from "@/api/register/index.js";
export default {
  components: {},
  data() {
    return {
      show: true,
      btnLoading:false,
      cardList: [
        {
          name: "微信支付",
          background:
            "linear-gradient(270deg, #05D267 6.65%, rgba(0, 207, 99, 0.64) 93.53%)",
          src: require("../../../../assets/img/payCard/wechat.svg"),
          type: "wechat",
          disabled: false,
          status: "NEED_SIGN",
          style: "#C1C1C1",
          auditDetailList:[],
          info:{},
        },
        {
          name: "支付宝",
          background:
            "linear-gradient(89.91deg, rgba(6, 180, 253, 0.63) 6.53%, #06B4FD 95.79%)",
          src: require("../../../../assets/img/payCard/zfb.svg"),
          type: "alipay",
          disabled: false,
          status: "NEED_SIGN",
          style: "#C1C1C1",
          auditDetailList:[],
          info:{},
        },
        {
          name: "数字人民币",
          background:
            "linear-gradient(268.81deg, #E50020 10.7%, rgba(232, 0, 32, 0.62) 85.8%)",
          src: require("../../../../assets/img/payCard/number.svg"),
          type: "RMB",
          disabled: true,
          status: "NEED_SIGN",
          style: "#C1C1C1",
          auditDetailList:[],
          info:{},
        },
        {
          name: "中国银联",
          background:
            "linear-gradient(270deg, #D4DEE2 8.81%, rgba(217, 227, 232, 0.6) 88.13%)",
          src: require("../../../../assets/img/payCard/card.svg"),
          type: "bankard",
          disabled: true,
          status: "NEED_SIGN",
          style: "#C1C1C1",
          auditDetailList:[],
          info:{},
        },
      ],
      qdoneWechatMerInfo: {}, //微信开通信息
      qdoneALiPayMerInfo: {}, //支付宝开通信息
      // auditDetailList: [
      //   {
      //     outRequestNo: "420100c1791a9eba0911ec8ce0f2b2d3432abf",
      //     paramName: "",
      //     rejectReason: "银行卡账号和账户名不匹配",
      //   },
      //   {
      //     outRequestNo: "420100c1791a9eba0911ec8ce0f2b2d3432abf",
      //     paramName: "",
      //     rejectReason: "营业执照和企业名称不匹配",
      //   },
      // ], //驳回原因详情
    };
  },
  mounted() {},
  created() {
    this.init();
  },
  filters: {
    signStatFilter(type) {
      const typeMap = {
        UNSIGNED: "未开通 ",
        SIGNED: "已开通",
        NOT_SIGNABLE: "开通失败",
      };
      return typeMap[type];
    },
    applymentStateFilter(type) {
      const typeMap = {
        CHECKING: "：资料校验中",
        ACCOUNT_NEED_VERIFY: "待账户验证",
        AUDITING: "审核中",
        REJECTED: "开通失败",
        NEED_SIGN: "未开通",
        FINISH: "已开通",
        FROZEN: "已冻结",
        CANCELED: "已作废",
      };
      return typeMap[type];
    },
  },
  methods: {
    async init() {
      this.btnLoading = true;
      let params = {
         loginPlatformCode:sessionStorage.getItem("loginPlatformCode"),
         platformCode:sessionStorage.getItem("platformCode"),
         usessionid:sessionStorage.getItem("usessionid"),
         externalId:sessionStorage.getItem("platformCode")+sessionStorage.getItem("orgId"),
        // externalId: "420100c1791a9eba0911ec8ce0f2b2d3432abf",
        // usessionid: "a29f7524ec7611ec837e0203154a51f1",
        // platformCode: "420100",
        // loginPlatformCode: "420100",
      };
      const { result, data, desc } = await queryPayChannelStatus(params);
      if (result == "000000" && data) {
        this.btnLoading = false;
        data.forEach((it) => {
          if (it.channelName == "WECHAT") {
            this.cardList[0].status = it.status || "NEED_SIGN";
            if (it.status == "FINISH") {
              this.cardList[0].info = it.qdoneWechatMerInfo;
            } else if (
              it.status == "REJECTED" ||
              it.status == "FROZEN"
            ) {
              this.cardList[0].info = it.qdoneWechatMerInfo;
              if(it.auditDetailList){
                 this.cardList[0].auditDetailList = it.auditDetailList;
              }
            }
          }else if(it.channelName == "ALIPAY"){
              this.cardList[1].status = it.status || "NEED_SIGN";
            if (it.status == "FINISH") {
              this.cardList[1].info = it.qdoneALiPayMerInfo;
            } else if (
              it.status == "REJECTED" ||
              it.status == "FROZEN"
            ) {
              this.cardList[1].info = it.qdoneALiPayMerInfo;
              if(it.auditDetailList){
                 this.cardList[1].auditDetailList = it.auditDetailList;
              }
            }
          }
        });
      } else {
        this.$message({
          type: "error",
          message: desc,
        });
      }
    },
    open(item) {
      //  console.log('点击开通',item);
      this.show = false;
      if (item.type == "wechat") {
        this.$router.push({
          path: "/operate/payChannel/wechat",
          query: { type: "open" },
        });
      } else if (item.type == "alipay") {
        this.$router.push({
          path: "/operate/payChannel/alipay",
          query: { type: "open" },
        });
      } else {
        this.$message({
          type: "warring",
          message: "此功能还在开发中",
        });
        return;
      }
    },
    uplate(it) {
       this.$router.push({
          path: `/operate/payChannel/${it.type}`,
          query: { type: 'uplate',info: it.info},
        });
    },
    async see(it) {
      console.log('点击查看',it);
      this.$router.push({
        path: `/operate/payChannel/${it.type}`,
        query: { type: "see", info: it.info},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0 30px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 20px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
.query {
  .card {
    float: left;
    margin: 0 3% 3% 0;
    // position: absolute;
    width: 280px;
    height: 160px;
    .tip {
      position: relative;
      top: 19%;
      right: -78.5%;
      width: 60px;
      height: 30px;
      text-align: center;
      color: #fff;
      line-height: 30px;
    }
    .card_top {
      width: 100%;
      height: 107px;
      line-height: 107px;
      text-align: center;
      .pay_content {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 50px;
          height: 50px;
        }
        span {
          margin-left: 20px;
          font-size: 24px;
          font-style: PingFang SC;
          color: #fff;
        }
      }
    }
    .card_bottom {
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #fafafa;
    }
  }
}
.el-button--text {
  font-size: 16px;
}
</style>
